import { create } from "zustand";

export type Crumb = {
    title: string;
    url: string;
    route: { path: string };
};

type BreadcrumbsState = {
    crumbs: Crumb[];
    setCrumbs: (c: Crumb[]) => void;
    resetCrumbs: () => void;
};

export const useBreadcrumbsStore = create<BreadcrumbsState>((set) => ({
    crumbs: [],
    setCrumbs: (c) => set({ crumbs: c }),
    resetCrumbs: () => set({ crumbs: [] }),
}));
